export const requisites = {
    ogrn: '1267700072420',
    inn: '9724238100',
    kpp: '772401001',
    okpo: '69120019',
    // oktao: '46407000000',
    // okfs: '16, Частная собственность',
    // oktmo: '46707000001',
    // okogu: '4210014',
    okopf: '12300',
    registration_data: '04.03.2026',
    ur_address: '115516, город Москва, Бакинская ул, д. 20, помещ. 18/1/1',
}

export const contacts = {
    sales_department_phone: '79014170477',
    sales_department_phone_2: '74952753077',
    commerce_department_phone: '78003502059',
    logistics_department_phone: '74952751190',
    info_mail: 'sale@full-stroy.ru',
    whatsapp: 'https://api.whatsapp.com/send/?phone=79256649222&text&type=phone_number&app_absent=0',
    telegram: 'https://t.me/dorozhnye_plity_bot',
    max: 'https://max.ru/u/f9LHodD0cOL6sbuSDVac-qnRDgwCs7oT1Xx1fzpFpQFwc0KEV3sgwoEm8D0',
    yandex_map_link: 'https://yandex.com/maps/-/CLUrVH7O',
    address: 'Москва, Домодедово, Промышленная ул. 38',
}
